import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Board,
  Headline,
  HeadlineContainer,
  StyledIcon,
  HeadlineImage,
  SubTitle,
  Title,
  TitleContainer,
  NoDataTitle,
} from "./styles";
import { htmlToText } from "../../utils/helpers";

export const Card = ({
  bgColor,
  viewCount,
  subTitle,
  icon,
  image,
  text,
  analyticsData,
}) => {
  const navigate = useNavigate();

  const handleHeadlineClick = () => {
    if (analyticsData?.id) {
      navigate(`/wheel/${analyticsData.id}`);
    }
  };

  return (
    <Board>
      <TitleContainer
        backgroundColor={bgColor}
        noData={viewCount === 0 && !text}
      >
        <Title>{viewCount}</Title>
        <SubTitle>
          <StyledIcon src={icon} />
          {subTitle}
        </SubTitle>

        {viewCount === 0 && !text && (
          <NoDataTitle>No Data Here Yet</NoDataTitle>
        )}
      </TitleContainer>
      {viewCount > 0 && text && (
        <HeadlineContainer>
          <HeadlineImage src={image} />
          <Headline onClick={handleHeadlineClick} style={{ cursor: "pointer" }}>
            {htmlToText(text)}
          </Headline>
        </HeadlineContainer>
      )}
    </Board>
  );
};
